import { Controller } from "@hotwired/stimulus"

// Shows browser-appropriate bookmark instructions on click.
export default class extends Controller {
  bookmark(event) {
    event.preventDefault()
    const isMac = navigator.userAgent.toLowerCase().indexOf('mac') !== -1
    alert('Press ' + (isMac ? 'Cmd' : 'Ctrl') + '+D to bookmark this page.')
  }
}
